import { render, staticRenderFns } from "./Avatar-Change.vue?vue&type=template&id=738ce24c&scoped=true"
import script from "./Avatar-Change.vue?vue&type=script&lang=js"
export * from "./Avatar-Change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ce24c",
  null
  
)

export default component.exports